// extracted by mini-css-extract-plugin
export default {"content":"Odovg1cMu2fLyt2Ib24U"};